import { Trans } from "@lingui/react/macro";
import { motion } from "motion/react";
import { useEffect, useState } from "react";

const testimonials = [
  {
    quote: "The CV builder made it so easy to create my professional resume. I got hired within two weeks of applying!",
    name: "Rajesh Kumar",
    title: "Electrician, Dubai",
  },
  {
    quote:
      "I've never had a proper CV before. This tool helped me build one in just 10 minutes — and it looks amazing.",
    name: "Amara Okafor",
    title: "Warehouse Supervisor, Abu Dhabi",
  },
  {
    quote: "Simple, free, and professional. Exactly what blue-collar workers need to get better job opportunities.",
    name: "Roshan Perera",
    title: "Heavy Driver, Sharjah",
  },
  {
    quote: "I shared my CV link directly with the recruiter and got a callback the same day. Great tool!",
    name: "Juan Carlos Reyes",
    title: "HVAC Technician, Dubai",
  },
  {
    quote:
      "As a recruitment professional, I recommend Huntr CV to all our candidates. It's fast and produces clean, professional resumes.",
    name: "Priya Sharma",
    title: "HR Manager, Al Ain",
  },
  {
    quote:
      "Finally a resume builder that works on my phone. I created my CV during lunch break and applied the same evening.",
    name: "Bikram Tamang",
    title: "Plumber, Ajman",
  },
  {
    quote: "The templates look so professional. My new employer said my CV stood out from hundreds of applications.",
    name: "Maria Santos",
    title: "Housekeeping Staff, Dubai",
  },
];

export function Testimonials() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section id="testimonials" className="py-20">
      <div className="mx-auto max-w-3xl px-4 text-center">
        <p className="text-sm font-medium tracking-widest text-primary uppercase">
          <Trans>What People Say</Trans>
        </p>
        <h2 className="mt-2 text-3xl font-bold tracking-tight md:text-4xl">
          <Trans>Trusted by Workers Worldwide</Trans>
        </h2>

        <motion.blockquote
          key={active}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.4 }}
          className="mt-10 text-lg leading-relaxed text-muted-foreground italic md:text-xl"
        >
          "{testimonials[active].quote}"
        </motion.blockquote>

        <motion.div
          key={`name-${active}`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.15 }}
          className="mt-4"
        >
          <p className="font-semibold text-foreground">{testimonials[active].name}</p>
          <p className="text-sm text-muted-foreground">{testimonials[active].title}</p>
        </motion.div>

        <div className="mt-6 flex justify-center gap-2">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              className={`h-2 w-2 rounded-full transition-colors ${i === active ? "bg-primary" : "bg-muted"}`}
              aria-label={`Testimonial ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
